/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

(function () {
  'use strict';

  // This extension handles any synergy that we have with the tab button when doing page editing/creation. It also
  // includes SHIFT-TAB and any other combination of tab. It strips MediumEditor's implemented events for tab, so
  // we have full control.
  var TabBehaviorExtension = MediumEditor.Extension.extend({ // jshint ignore: line

    name: 'tabBehavior',

    constructor: function (options) {
      MediumEditor.Extension.call(this, options); // jshint ignore: line
    },

    init: function() {
      var that = this;

      // This is used to remove the functionality of the "editableKeydownTab" that was created by MediumEditor.
      // It will slice out the event that MediumEditor applied to the editableKeydownTab custom event, and replace
      // it with our own, that handles all of the same things, but allows us also to change certain functionality.
      setTimeout(function() {
        that.base.events.customEvents.editableKeydownTab.splice(1, 1);
      });

      // We register our own listener here, which will be one of two originally, we use the timeout above to
      // remove Medium Editor's listener. So ours is the only one that remains.
      this.subscribe('editableKeydownTab', this.handleTabKeydown.bind(this));
    },

    handleTabKeydown: function(e) {
      var lowestNode = MediumEditor.selection.getSelectionStart(this.base.options.ownerDocument); // jshint ignore: line
      var blockNode = MediumEditor.util.getClosestBlockContainer(lowestNode); // jshint ignore: line
      var  tag = blockNode && blockNode.nodeName.toLowerCase();

      // If the shift key is pressed, let's handle it in a different function.
      if (event.shiftKey) {
        return this.handleShiftTabKeydown(e, blockNode, tag);
      }

      // Any tag not registered here will just be handled normally as a tab command.
      switch (tag) {
        // This is the MediumEditor default tab functionality that needs to continue to be used on "pre" tags.
        case 'pre':
          event.preventDefault();
          MediumEditor.util.insertHTMLCommand(this.options.ownerDocument, '    '); // jshint ignore: line
          break;
        // This will handle tab behavior for list-items only.
        case 'li':
          // This will check if the current node is the first-node of the list by grabbing the parent list,
          // if it is the first-node, we run outdent as we cannot prevent the MediumEditor defaults without
          // globally deactivating default behavior.
          event.preventDefault();
          var parentNode = blockNode.parentNode;

          // Check if the current node we're in, is the first list item in a list.
          if (parentNode.firstChild !== blockNode) {
            this.document.execCommand('indent', false, null);
          }
          break;
      }
    },

    handleShiftTabKeydown: function(event, node, tag) {
      // Any tag not registered here will just be handled normally as a shift-tab command.
      switch (tag) {
        case 'li':
          event.preventDefault();
          // Check to make sure that the shift key is pressed when the tab button is pressed in the lists.
          var parentElement = $(MediumEditor.selection // jshint ignore: line
            .getSelectedParentElement(window.getSelection().getRangeAt(0))).parent();

          // This means that the parentElement (the highest selected tag) is the highest level ul/ol in the
          // chain, so instead of simply unwrapping, we need to also replace the "li" with "p" tags, and
          // unindent the other lists by one.
          if (parentElement.parent().hasClass('bulb-page-content')) {
            var highestListItems = parentElement.children();

            // This will go through and determine which node we're effecting, and work exclusively on that
            // node, so we don't unindent the entire first line when we unindent a bulleted list item.
            for (var i = 0; i < highestListItems.length; i++) {
              var current = highestListItems[i];
              if (current === node) {
                this.document.execCommand('outdent', false, null);
                // This is the process required to change a block to a paragraph on the fly.
                this.document.execCommand('formatBlock', false, 'pre');
                var theNewParagraph = $('pre')[0];
                $(theNewParagraph).replaceWith('<p>' + $(theNewParagraph).html() + '</p>');
              }
            }
          } else {
            // TODO FUTURE MCSL: We cannot use execCommand('outdent') on second+ level bulleted lists, so
            // I need to figure out a way to handle all of the logic that execCommand('outdent') does and
            // do the actual code here. For now, this will just unwrap all of the list items by one level.
            // It isn't great, but it's fine for now.
            $(node).unwrap();
          }
          break;
      }
    }
  });

  MediumEditor.extensions.tabBehavior = TabBehaviorExtension; // jshint ignore: line
}());
